// src/store/thunks/inquiriesActions.js

import request from "../../utils/request";
import {
  fetchInquiriesPending,
  fetchInquiriesFulfilled,
  fetchInquiriesRejected,
  fetchInquiryPending,
  fetchInquiryFulfilled,
  fetchInquiryRejected,
  createInquiryPending,
  createInquiryFulfilled,
  createInquiryRejected,
  replyInquiryPending,
  replyInquiryFulfilled,
  replyInquiryRejected,
  updateInquiryPending,
  updateInquiryFulfilled,
  updateInquiryRejected,
} from '../slices/inquiriesSlice';
import { createAsyncThunk } from "@reduxjs/toolkit";
// GET /inquiries
export const fetchInquiries = () => async dispatch => {
  dispatch(fetchInquiriesPending());
  try {
    const { data } = await request.get('/inquiries');
    dispatch(fetchInquiriesFulfilled(data));
  } catch (err) {
    dispatch(fetchInquiriesRejected(err.toString()));
  }
};

// GET /inquiries/:id
export const fetchInquiry = id => async dispatch => {
  dispatch(fetchInquiryPending());
  try {
    const { data } = await request.get(`/inquiries/${id}`);
    dispatch(fetchInquiryFulfilled(data));
  } catch (err) {
    dispatch(fetchInquiryRejected(err.toString()));
  }
};

// POST /inquiries
export const createInquiry = inquiryData => async dispatch => {
  dispatch(createInquiryPending());
  try {
    const { data } = await request.post('/inquiries', inquiryData);
    dispatch(createInquiryFulfilled(data));
  } catch (err) {
    dispatch(createInquiryRejected(err.toString()));
  }
};

// POST /inquiries/:id/responses
export const replyInquiry = ({ id, responder, message, templateUsed }) => async dispatch => {
  dispatch(replyInquiryPending());
  try {
    const payload = { responder, message, templateUsed };
    const { data } = await request.post(`/inquiries/${id}/responses`, payload);
    dispatch(replyInquiryFulfilled(data));
  } catch (err) {
    dispatch(replyInquiryRejected(err.toString()));
  }
};

// PATCH /inquiries/:id
export const updateInquiry = (id, updates) => async dispatch => {
  dispatch(updateInquiryPending());
  try {
    const { data } = await request.patch(`/inquiries/${id}`, updates);
    dispatch(updateInquiryFulfilled(data));
  } catch (err) {
    dispatch(updateInquiryRejected(err.toString()));
  }
};

// src/store/thunks/inquiriesActions.js
export const sendInquiryEmail = createAsyncThunk(
  'inquiries/sendEmail',
  async ({ id, from, to, subject, body, threadId, userId }, { rejectWithValue }) => {
    try {
      const payload = { id, from, to, subject, body, threadId, userId };
      const { data } = await request.post(
        `/inquiries/${id}/send-email`,
        payload,
        { withCredentials: true }
      );
      return data.messageRecord; 
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
